/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { createIncident } from 'store/modules/tools_status/actions';
import { ToolsTypes } from 'store/modules/tools_status/types';

interface ToolModalProps {
  statusList: ToolsTypes[];
  loadTools: () => void;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}

const ToolModal: React.FC<ToolModalProps> = ({
  statusList,
  loadTools,
  setShowModal,
  showModal,
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    selectedTool: '',
    selectedStatus: '',
    description: '',
    expireIn: '',
  });

  const selectStatusOptions = statusList.map((status) => ({
    label: status.tool_name,
    value: status.cache_name,
  }));

  const handleInputChange = (field: string, value: string | number) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const saveNewIncident = () => {
    const { selectedTool, selectedStatus, description, expireIn } = formData;
    dispatch(createIncident(selectedTool, selectedStatus, description, expireIn));
    loadTools();
    setShowModal(false);
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Atualizar Status</h5>
          <button type="button" className="close" onClick={() => setShowModal(false)}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-md-6">
              <label>Selecione a Ferramenta:</label>
              <Select
                defaultValue={null}
                closeMenuOnSelect
                isClearable
                onChange={(selected) => handleInputChange('selectedTool', selected?.value || '')}
                options={selectStatusOptions}
              />
            </div>
            <div className="col-md-6">
              <label>Selecione o status:</label>
              <Select
                defaultValue={null}
                closeMenuOnSelect
                isClearable
                onChange={(selected) => handleInputChange('selectedStatus', selected?.value || '')}
                options={[
                  { label: 'Indisponibilidade Parcial', value: 'partial' },
                  { label: 'Indisponibilidade Total', value: 'total' },
                ]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <label>Descrição:</label>
              <input
                type="text"
                className="form-control"
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label>Tempo da Ocorrência:</label>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  value={formData.expireIn}
                  onChange={(e) => handleInputChange('expireIn', e.target.value)}
                />
                <div className="input-group-append">
                  <span className="input-group-text">minutos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-success" onClick={saveNewIncident}>
            Salvar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ToolModal;
